import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { isPlaceholder } from "@/config/site";

export const SocialCard = ({ link, Icon }) => {
  const handleClick = (e) => {
    if (isPlaceholder(link.url)) {
      e.preventDefault();
      toast(`${link.name} link goes here — add the real URL in config/site.js`);
    }
  };

  return (
    <div data-testid={`social-card-${link.id}`} className="flex flex-col justify-between border border-border-dark bg-surface-dark p-8 transition-colors hover:border-brand-purple/60">
      <div>
        <div className="inline-flex h-12 w-12 items-center justify-center border border-border-dark text-brand-purple">
          <Icon className="h-6 w-6" />
        </div>
        <h3 className="mt-5 font-heading text-3xl uppercase text-white">{link.name}</h3>
        <p className="mt-1 text-sm text-white/40">{link.handle}</p>
        <p className="mt-3 text-sm text-white/60">Text goes here</p>
      </div>
      <a
        href={isPlaceholder(link.url) ? "#" : link.url}
        onClick={handleClick}
        target={isPlaceholder(link.url) ? undefined : "_blank"}
        rel="noopener noreferrer"
        data-testid={`social-visit-${link.id}`}
        className="mt-6 inline-flex items-center gap-2 self-start border border-white/20 px-5 py-2.5 font-subheading text-xs font-semibold uppercase tracking-wide text-white transition-colors hover:border-brand-purple hover:bg-brand-purple"
      >
        Visit Channel <ExternalLink className="h-3.5 w-3.5" />
      </a>
    </div>
  );
};
